import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Link,Outlet,Navigate } from "react-router-dom";
import { loginSuccess } from "../login/loginSlice";
import { getUserProfile } from "../backend/dashboard/userAction";

import { fetchNewAccessJWT } from "../../api/userApi";

import MasterPage  from '../backend/layout/MasterPage';

/*export const PrivateRoute = ({ children, ...rest }) => {
    const dispatch = useDispatch();
    const { islogIn } = useSelector(state => state.login);
    const { user } = useSelector ( state => state.user) ;
    console.log('PrivateRoute children'+ children+'islogIn'+islogIn);
    useEffect(() => {
        const updateAccessJWT = async () => {
            const result = await fetchNewAccessJWT();
            result && dispatch(loginSuccess());
        };

        !user.id && dispatch(getUserProfile());

        !sessionStorage.getItem("accessJWT") && 
        localStorage.getItem("crmSite") && 
        updateAccessJWT();

        !islogIn  && sessionStorage.getItem("accessJWT") && dispatch(loginSuccess());
    }, [dispatch, islogIn, user.id]);*/


   
    /*return (
        <Route 
        {...rest}
        render={({ location })  =>
            islogIn ? (
                <MasterPage>{children}</MasterPage>
                
            ) : (
                <Link 
                    to={{
                        pathname: "/",
                        state: { from: location },
                    }}
                />
            )
        }
        />
    );
    
};*/


 const PrivateRoute = ({ accessIsLogIn, children }) => {
    console.log('private',accessIsLogIn);
if (accessIsLogIn || accessIsLogIn!==null) {
return <Navigate to="/dashboard" replace />;
}
return children;
};
export default PrivateRoute;


